import React, { useContext } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { styled } from 'styled-components';
import { Context } from '@components/Context';
import { Price } from '@components/shared/PurchaseOptions';
import Select from '@components/shared/Select';
import { getProductPrice } from '@utils/price';
import { useShoppingContext } from './ProductShoppingContext';

const ProductPaymentOptions: React.FC = () => {
  const { state } = useContext(Context);
  const { currency, country } = state;
  const {
    price,
    paymentOptions,
    paymentOptionSelected,
    productHeaderData,
    setProductId,
    setPaymentOptionSelected: setOptionSelected,
    setPrice
  } = useShoppingContext();
  const { productCode } = productHeaderData;
  const { t } = useTranslation();

  if (!paymentOptions?.length) {
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      <Label>{t('components.choose-colour')}</Label>
      <Select
        style={{ marginTop: '15px', marginBottom: '15px', width: '100%', alignSelf: 'center' }}
        options={paymentOptions}
        defaultValue={paymentOptionSelected}
        onSelectCallback={async (option) => {
          const newProductId = `${productCode}${option.value}`;
          setProductId(newProductId);
          const maskPrice = await getProductPrice(newProductId, currency, country);
          setOptionSelected(option);
          setPrice(maskPrice.price);
        }}
        hasSelectedIndicator={true}
      >
        <PriceStyled $color="transparent">
          {currency.symbol}
          {price?.toFixed(2)}
        </PriceStyled>
      </Select>
    </div>
  );
};

export default ProductPaymentOptions;

const Label = styled.p`
  text-transform: uppercase;
  font-family: BrownStd;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.75px;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const PriceStyled = styled(Price)`
  margin-left: auto;
  padding: 0;
`;
